import React, { useState } from 'react';
import { Modal, Button, Form, ProgressBar, Spinner } from 'react-bootstrap';

const dropZoneStyle = {
  border: '2px dashed #00A0D450',
};

const OnboardingUploadModal = ({ show, onHide, onUpload, uploading, isDocumentUpload = false, categoryOptions = [], isAssignmentUpload = false }) => {
  const role = localStorage.getItem('role');
  const isDirector = ['director', 'admin', 'attending'].includes(role);
  const [files, setFiles] = useState([]);
  const [fileCategories, setFileCategories] = useState({});

  const handleFiles = (fileList) => {
    const arr = Array.from(fileList);
    setFiles(prev => [...prev, ...arr]);
    // Initialize categories for new files
    const newCategories = {};
    arr.forEach(file => {
      newCategories[file.name] = '';
    });
    setFileCategories(prev => ({ ...prev, ...newCategories }));
  };

  const onDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.dataTransfer?.files?.length) {
      handleFiles(e.dataTransfer.files);
    }
  };

  const onBrowse = (e) => {
    if (e.target.files?.length) {
      handleFiles(e.target.files);
      e.target.value = '';
    }
  };

  const removeFile = (idx) => {
    const fileToRemove = files[idx];
    setFiles(prev => prev.filter((_, i) => i !== idx));
    setFileCategories(prev => {
      const newCategories = { ...prev };
      delete newCategories[fileToRemove.name];
      return newCategories;
    });
  };

  const handleSubmit = async () => {
    if (files.length === 0) return;
    // Create array of files with their categories
    const filesWithCategories = files.map(file => ({
      file,
      category: fileCategories[file.name] || ''
    }));
    await onUpload(filesWithCategories);
    setFiles([]);
    setFileCategories({});
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton className="border-0">
        <div className="d-flex flex-column gap-2 w-100">
          <Modal.Title>{isDocumentUpload ? 'Upload Documents' : (isAssignmentUpload ? 'Add Files for Submission' : 'Upload Completed Documents')}</Modal.Title>
          <div className="text-hl"></div>
        </div>
      </Modal.Header>
      <Modal.Body>
        {uploading && (
          <div className="mb-3">
            <div className="d-flex align-items-center gap-2 mb-2">
              <Spinner animation="border" size="sm" />
              <span className="small text-muted">Uploading files...</span>
            </div>
            <ProgressBar animated striped now={100} variant="primary" />
          </div>
        )}
        {isDocumentUpload && (
          <div className="alert alert-info mb-3">
            <div className="d-flex align-items-start">
              <i className="bi bi-info-circle-fill me-2 mt-1"></i>
              <div>
                <strong>Upload Documents</strong>
                <p className="mb-0 small">Upload documents that residents will need to complete. These can be forms, policies, or any files residents should review or fill out. You can assign individual documents or add them to packages for better organization.</p>
              </div>
            </div>
          </div>
        )}
        <div className="d-flex flex-column align-items-center justify-content-center p-5 rounded-3 bg-primary"
          style={dropZoneStyle}
          onDragOver={(e) => { e.preventDefault(); e.stopPropagation(); }}
          onDrop={onDrop}
        >
          <span className="d-inline-flex align-items-center justify-content-center rounded-2 bg-primary mb-2"><i className="bi bi-cloud-upload-fill fs-2"></i></span>
          <div className="mb-2 text-muted small">Choose a file Or drag and drop it here</div>
          <label className="btn btn-light-solid mb-0">
            Browse files
            <input type="file" multiple hidden onChange={onBrowse} accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.png,.jpg,.jpeg,.gif,.webp,.txt" />
          </label>
        </div>
        {files.length > 0 && (
          <div className="mt-3">
            <div className="fw-semibold mb-2">Selected files</div>
            <ul className="list-group">
              {files.map((f, i) => (
                <li key={i} className="list-group-item">
                  <div className="d-flex justify-content-between flex-row align-items-center">
                    <span className="text-truncate" style={{ maxWidth: 280 }}>{f.name}</span>
                    {isDirector && (
                      <Form.Group>
                        <Form.Control
                          size="sm"
                          list={`category-options-${i}`}
                          placeholder="Select or type a category"
                          value={fileCategories[f.name] || ''}
                          onChange={(e) => setFileCategories(prev => ({ ...prev, [f.name]: e.target.value }))}
                        />
                        <datalist id={`category-options-${i}`}>
                          {categoryOptions.map((opt) => (
                            <option key={opt} value={opt} />
                          ))}
                        </datalist>
                      </Form.Group>
                    )}
                    <Button size="sm" variant="outline-danger" onClick={() => removeFile(i)}><i className="bi bi-x-lg"></i></Button>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer className="border-0">
        <Button variant="secondary" size="sm" onClick={onHide} disabled={uploading}>Cancel</Button>
        <Button variant="primary" size="sm" onClick={handleSubmit} disabled={uploading || files.length === 0}>
          {uploading ? 'Uploading...' : (isAssignmentUpload ? 'Add Files' : 'Upload')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default OnboardingUploadModal;


